import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

export type QuestionOption = {
	id: string;
	name: string;
	short_name: string;
	option_value: string;
	priority: number;
};

interface ScheduleQuestionRadioGroupProps {
	options: QuestionOption[];
	handleChange: (short_name: string) => void;
	answer: string | string[];
	short_name: string;
}

export default function ScheduleQuestionRadioGroup({
	options,
	handleChange,
	answer,
	short_name,
}: ScheduleQuestionRadioGroupProps) {
	return (
		<RadioGroup aria-labelledby={short_name} sx={{pt: 2, gap: 1}}>
			{options.map((option: QuestionOption) => (
				<FormControlLabel
					onChange={() => handleChange(option.short_name)}
					checked={answer === option.short_name}
					value={option.short_name}
					sx={{alignItems: 'center'}}
					control={<Radio sx={{ ml: 0.3 }} />}
					label={
						<Typography variant="bodyMediumBook" color="text.secondary">
							{option.option_value}
						</Typography>
					}
					key={option.short_name}
				/>
			))}
		</RadioGroup>
	);
}
